// @ts-check
import styled from 'styled-components';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';
import SetupSSO from 'images/characters/setup-sso.svg';
import { LBButton } from '@linearb/buzz';

const StyledSVG = styled.img`
  width: 10rem;
  height: 12rem;
`;

const SingleSignOnSetup = ({ onSetupClicked }) => {
  return (
    <Flex items='center' justify='center' direction='column'>
      <StyledSVG src={SetupSSO} />
      <Padding padding='small'>
        <Text color='shuttleGray' size='large'>
          Enable users to log in via your SSO provider for added security
        </Text>
      </Padding>

      <Padding t='small'>
        <LBButton
          onClick={onSetupClicked}
          size='lg'
          variant='outline'
          data-testid='set-up-sso'
        >
          Set up SSO
        </LBButton>
      </Padding>
    </Flex>
  );
};

export default SingleSignOnSetup;
